import axios, { AxiosPromise } from 'axios';
import { IRecipe } from '../../../../@types/model/integration/recipe';
import { IRecipeTable } from '../../../../@types/model/integration/recipeTable';
import { IRecipeField } from '../../../../@types/model/integration/recipeField';

export default class RecipeHttpService {
    public static getRecipeData() : AxiosPromise<Array<IRecipe>> {
        return axios.get(`${API_URL}/v1/Recipe`);
    }

    public static addOrUpdateRecipe(data : IRecipe) : AxiosPromise<IRecipe> {
        return axios.post(`${API_URL}/v1/Recipe/PostRecipe`, data);
    }

    public static getTables() : AxiosPromise<Array<IRecipeTable>> {
        return axios.get(`${API_URL}/v1/Recipe/Tables`);
    }

    public static getFields(tableName : string) : AxiosPromise<Array<IRecipeField>> {
        return axios.get(`${API_URL}/v1/Recipe/Fields`, {
            params: {
                tableName,
            },
        });
    }

    public static testRecipe(recipeId : number, tableId : number) : AxiosPromise<string> {
        return axios.get(`${API_URL}/v1/Recipe/Test`, {
            params: {
                recipeId,
                tableId,
            },
        });
    }
}
